<template>
  <v-container fluid fill="height" fill-height >

    <v-row>
      <v-col cols="12">
        <v-card class="transparent elevation-0">
          <v-card-text>

            <v-carousel cycle :height="tamanioPantalla" hide-delimiter-background hide-delimiters show-arrows-on-hover :interval="100000">

              <template v-slot:prev="{ on, attrs }">
                <v-btn icon large color="white" v-bind="attrs" v-on="on" >  <v-icon> mdi-chevron-left </v-icon> </v-btn>
              </template>
              
              <v-carousel-item :contain="$vuetify.breakpoint.name === 'xs'? true : false" >
                <v-img src="@/assets/images/fondo/fondo1.png" aspect-ratio="2" contain></v-img>
              </v-carousel-item>

              <v-carousel-item :contain="$vuetify.breakpoint.name === 'xs'? true : false" >
                <v-img src="@/assets/images/fondo/fondo2.png" aspect-ratio="2" contain></v-img>
              </v-carousel-item>

            </v-carousel>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row >
      <v-col cols="12">
        <DiagnosticoSistema />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
  import DiagnosticoSistema    from '@/components/diagnostico/DiagnosticoSistema.vue'

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'
  import mixinLeads            from '@/mixins/mixinLeads'
  import basicosTablas         from '@/mixins/basicosTablas'
  import invitacionCDMX from '@/assets/posada-cdmx.jpg';
  import invitacionMty from '@/assets/posada_invitacion.jpg';


  export default {
    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      //datos que se desplegaran en las 2 tablas
      prospectos: [],
      usuarios: [],
      usuario: null,
      dialogUsuario: false,

      headers: [
        { text: "Folio"      , value: "folio" },
        { text: "Plantel"    , value: "plantel" },
        { text: "Telefono"   , value: "telefono" },
        { text: "Nombre"     , value: "nombre_completo" },
        { text: "Vendedora"  , value: "name" },
        { text: "Estatus"    , value: "estatus" },
        { text: "Completo"   , value: "completo" },
        { text: "Match"      , value: "match" },
        { text: "Fecha"      , value: "fecha_creacion" },
        { text: "Campaña"    , value: "ReferralSourceId" },
        { text: "Preview"    , value: "ReferralSourceUrl" },
        { text: "Encabezado" , value: "ReferralHeadline" },
        { text: "Tipo Match" , value: "tipo_match" },
      ],

      fechaini: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      checkGeneral: 1,
      checkCompletos: 1,
      checkIncompletos: 1,
      checkMerca: 1,
      checkSucursal: 1,

      search: "",

      escuela: 1,

      vendedoras: [],

      headersAll:[],
      search2:'',
      contactosActivos:[],

      contactosVsFecha:[],
      contactosInscritos:[],

      cursos_escuela:[],
      medios_contacto:[],

      searchTelefono:'',

      headers3:[
        { text: "Folio"         , value: "folio"            },
        { text: "Nombre"        , value: "nombre_completo"  },
        { text: "Creó"          , value: "creo"             },
        { text: "Plantel"       , value: "plantel"          },
        { text: "Usuario"       , value: "twilio"           },
        { text: "Sistema"       , value: "sistema"          },
        { text: "Mensaje"       , value: "mensaje"          },
        { text: "Fecha"         , value: "fecha_creacion"   },
        { text: "Clasificación" , value: "clasificacion" },
      ],


      headersAlumnos:[
        { text: "alumno"        , value: "id_alumno"        },
        { text: "Nombre"        , value: "nombre_completo"  },
        { text: "Grupo"         , value: "grupo"            },
        { text: "Pagó"          , value: "fecha_pago"       },
        { text: "Clasif"        , value: "clasificacion"       },
      ],

      editedItem: {
        nombre_completo:'',
        idleds:'',
        escuela: 1,
        iddetalle_fuentes:0,
        idfuentes: 0,
        fuente: '',
        estatus: '',
        foraneo: 0,
        idcursos_escuela: 0,
        telefono:'',
        sucursal:0,
        nota_inicial:'El prospecto desea información',
        idmedio_contacto:0,
        idcampanias:0,
        id_sucursal_interes:0,
        curso_interes: 0,
        horario_interes:'',
        respondio: 0,
      },

      sucursales:[],
      sucursal:null,
      vendedoras:[],
      vendedoras_plantel:[],
      vendedora:null,
      campanias:[],
      campania:null,
      fuentes:[],

      tablaContactos: [],
      dialogMensajes: false,
      ciudad: 'sin ciudad'

    }),

    components:{
      Alerta,
      carga,
      DiagnosticoSistema,
    },

    mixins: [ validarErrores, funcionesExcel, mixinLeads, basicosTablas ],

    computed:{

      ...mapGetters('login', ['getdatosUsuarioERPERP', 'getEscuela']),

      tamanioPantalla () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return 'auto';
          break;
          default:
            return this.$vuetify.breakpoint.height - 160
          break;
        }
      },

      ...mapGetters('login',['getdatosUsuarioERPERP']),
      dialog (val) {

        val || this.close()
      },

      formTitle () {
        return this.editedIndex === -1 ? 'Agregar un LEAD' : 'Editar LEAD'
      },

      filterVendedoras( ){

        return this.vendedoras.filter( el => el.iderp == this.getdatosUsuarioERPERP.iderp )

      },

      detallesFilter(){
        return this.detalles ? this.detalles.filter(el => { return el.idfuentes == this.editedItem.idfuentes }) : []
      },

      campaniasFilter(){
        return this.campanias ? this.campanias.filter(el => { return el.idmedio_contacto == this.editedItem.idmedio_contacto }) : []
      },

      contadorVendedoras( ){

        let data = []

        for( const i in this.filterVendedoras ){

          const { nombre, iderp } = this.filterVendedoras[i]

          data.push({
            vendedora       : nombre,
            contactos       : this.prospectos.filter( el => el.usuario_asignado == iderp).length,
            contactosall    : this.prospectos.filter( el => el.usuario_asignado == iderp),
            contactosGeneral: this.prospectos.filter( el => el.usuario_asignado == iderp),
            iderp
          })

        }

        // Sacamos los últimos datos
        let uniqueArray = data.filter((obj, index, self) =>
          index === self.findIndex((el) => el.iderp === obj.iderp)
        );

        uniqueArray = uniqueArray.sort((a, b) => b.contactos - a.contactos);

        // Carga laboral
        for( const i in uniqueArray ){

          const { iderp, contactosall, vendedora } = uniqueArray[i]

          const existenContactos = this.contactosActivos.find( el => el.usuario_asignado == iderp )

          let contactos = existenContactos ? existenContactos.contactos : 0

          let sumaTotal = this.contactosActivos.map(item => item.contactos).reduce((prev, curr) => prev + curr, 0)

          let carga = (( contactos / sumaTotal ) * 100 ).toFixed( 2 )

          uniqueArray[i]['carga'] = carga

          let completos   = contactosall.filter( el => el.nombre_completo.match('TWILIO COMPLETO')).length
          let incompletos = contactosall.filter( el => el.nombre_completo.match('TWILIO INCOMPLETO')).length
          let merca       = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && [25,48,49,54,62,74,97,101].includes( el.idpuesto ) ).length
          let total       = completos + incompletos + merca

          uniqueArray[i]['contactosall']  = contactos
          uniqueArray[i]['completos']     = contactosall.filter( el => el.nombre_completo.match('TWILIO COMPLETO'))
          uniqueArray[i]['incompletos']   = contactosall.filter( el => el.nombre_completo.match('TWILIO INCOMPLETO'))
          uniqueArray[i]['merca']         = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && [25,48,49,54,62,74,97,101].includes( el.idpuesto ) )
          uniqueArray[i]['sucursal']      = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && ![25,48,49,54,62,74,97,101].includes( el.idpuesto ) )
          uniqueArray[i]['porcentajemkt'] = (( completos / total ) * 100 ).toFixed( 2 )

        }


        // Convencimiento
        for( const i in uniqueArray ){

          const { iderp, completos, incompletos, merca, sucursal } = uniqueArray[i]

          const existenContactos = this.contactosVsFecha.filter( el => el.usuario_asignado == iderp )

          let contactos = this.contactosVsFecha.filter( el => el.usuario_asignado == iderp ).length

          let inscritos = this.contactosInscritos.filter( el => el.id_usuario_ultimo_cambio == iderp ).length

          let inscritosCompletos   = completos.filter( el => el.mialumno ).length
          let inscritosIncompletos = incompletos.filter( el => el.mialumno ).length
          let inscritosMerca       = merca.filter( el => el.mialumno ).length
          let inscritosSucursal    = sucursal.filter( el => el.mialumno ).length

          let convencimientoCompletos   = (( inscritosCompletos   / completos.length   ) * 100 ).toFixed( 2 )
          let convencimientoIncompletos = (( inscritosIncompletos / incompletos.length ) * 100 ).toFixed( 2 )
          let convencimientoMerca       = (( inscritosMerca       / merca.length       ) * 100 ).toFixed( 2 )
          let convencimientoSucursal    = (( inscritosSucursal    / sucursal.length    ) * 100 ).toFixed( 2 )

          uniqueArray[i]['inscritosCompletos']     = inscritosCompletos
          uniqueArray[i]['inscritosIncompletos']   = inscritosIncompletos
          uniqueArray[i]['inscritosMerca']         = inscritosMerca
          uniqueArray[i]['inscritosSucursal']      = inscritosSucursal

          uniqueArray[i]['convencimientoCompletos']     = convencimientoCompletos
          uniqueArray[i]['convencimientoIncompletos']   = convencimientoIncompletos
          uniqueArray[i]['convencimientoMerca']         = convencimientoMerca
          uniqueArray[i]['convencimientoSucursal']      = convencimientoSucursal

          let convencimiento = contactos > 0 ? (( inscritos / contactos ) * 100 ).toFixed( 2 ) : 0

          uniqueArray[i]['convencimiento']    = convencimiento
          uniqueArray[i]['desglose']          = `( Inscritos( ${inscritos} ) / Contactos( ${contactos} ) ) * 100 `
          uniqueArray[i]['inscritos']         = inscritos
          uniqueArray[i]['inscritos_detalle'] = this.contactosInscritos.filter( el => el.id_usuario_ultimo_cambio == iderp )
          uniqueArray[i]['inscritos_fecha']   = this.filterVendedoras.filter( el => el.id_usuario_ultimo_cambio == iderp )

          // Primero, agregarmos las ventas del KPI al momento
          uniqueArray[i]['ventas_momento'] = this.totalMatriculas.filter( el => el.id_usuario_ultimo_cambio == iderp ).length
          uniqueArray[i]['porcentajeCompletos'] = (( completos.length / contactos ) * 100 ).toFixed( 2 )


          //

        }

        // Buscar la vendedora que mejor se acomode
        // Ordenar por % de convencimiento (desc) y luego por carga laboral (asc)
        uniqueArray.sort((a, b) =>
          b.convencimiento - a.convencimiento || parseFloat(a.contactos) - parseFloat(b.contactos)
        );

        // Agregar ranking y determinar si pueden recibir más contactos
        uniqueArray.forEach((vendedora, index) => {
          vendedora.puedeRecibir = (vendedora.contactos ) <= 5;
        });

        let contador3 = 0
        uniqueArray.forEach((vendedora, index) => {
          vendedora.ranking = vendedora.puedeRecibir ? contador3 + 1 : 0  ;
          contador3 += vendedora.puedeRecibir ? 1 : 0
        });

        let contador = uniqueArray.filter( el => el.ranking ).length
        uniqueArray.forEach((vendedora, index) => {
          vendedora.ranking = vendedora.ranking ? vendedora.ranking : contador + 1  ;
          contador += vendedora.ranking ? 1 : 0
        });


        // Ordenamos por ventas en kpi
        uniqueArray.sort((a, b) => b.ventas_momento - a.ventas_momento);
        for( const i in uniqueArray ){

          uniqueArray[i]['position_ventas_momento'] = parseInt( i ) + 1

        }


        // Ahora ordenamos por contactos
        uniqueArray.sort((a, b) => b.contactos - a.contactos);

        for( const i in uniqueArray ){

          uniqueArray[i]['position'] = parseInt( i ) + 1

        }


        for( const i in uniqueArray ){

          const { contactosGeneral, position_ventas_momento, position } = uniqueArray[i]

          uniqueArray[i]['TWILIO CDMX'] = contactosGeneral.filter( el => el.sistema == 'TWILIO CDMX' ).length

          uniqueArray[i]['TWILIO GUADALAJARA'] = contactosGeneral.filter( el => el.sistema == 'TWILIO GUADALAJARA' ).length

          uniqueArray[i]['TWILIO MONTERREY'] = contactosGeneral.filter( el => el.sistema == 'TWILIO MONTERREY' ).length

          uniqueArray[i]['TWILIO CRM INBI'] = contactosGeneral.filter( el => el.sistema == 'TWILIO CRM INBI' ).length

          uniqueArray[i]['SUCURSAL EXTERNO'] = contactosGeneral.filter( el => !el.sistema  ).length

          uniqueArray[i]['TODOS'] = contactosGeneral.length

          uniqueArray[i]['diferencia'] = position - position_ventas_momento
        }




        return uniqueArray

      },

      filterTablaContactos( ){

        let data = this.tablaContactos

        if( this.opZona != 'TODOS'){
          data = data.filter( el => el.sistema == this.opZona )
        }

        return data
      }

    },


    watch: {
      dialogUsuario(val) {
        val || this.close();
      },
    },

    async created() {

      if( this.getdatosUsuarioERPERP.idpuesto == 18 ){
        await this.initialize();
        await this.getVendedoras()
      }
    },

    //Methods
    methods: {

      //Obtener prospectos y usuarios
      async initialize() {
        this.cargar = true
        await this.getProspectosAllCambiar();
        await this.getVendedoras();

        this.cargar = false
      },

      getProspectosAllCambiar(){

        this.cargar = true
        const payload = {
          fechaini: this.fechaini,
          fechafin: this.fechafin,
          escuela : this.escuela
        }

        return this.$http.post("cambiar.prospecto.obtener.prospecto", payload ).then((response) => {
          this.contactosActivos   = response.data.contactosActivos;
          this.contactosVsFecha   = response.data.contactosVsFecha;
          this.contactosInscritos = response.data.contactosInscritos;
          this.prospectos         = response.data.prospectos;
          this.baseEscuela        = response.data.baseEscuela
          this.totalMatriculas    = response.data.totalMatriculas

          this.baseEscuela.push({ base: '', escuela: 0, zona: 'TODOS' },)
          this.cargar = false

          console.log( 'prospectos', this.contactosInscritos )

          for( const i in this.prospectos ){

            const { nombre_completo } = this.prospectos[i]

            this.prospectos[i]['completo'] = nombre_completo.match('INCOMPLETO') ? '🧊' : '🔥'

          }
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      // getVendedoras() {
      //   this.usuarios = []
      //   return this.$http.get("cambiar.prospecto.obtener.vendedora").then((response) => {
      //     this.usuarios = response.data;
      //   }).catch( error =>{
      //     this.validarError( error.response.data.message )
      //   }).finally( () => { this.cargar = false })
      // },

      //Cerrar Dialog Vendedora
      close() {
        this.dialogUsuario = false;
        this.dialog        = false;
      },

      //Modificar este para ver si funciona, esta traido de ActivarProspectos
      actualizar() {
        this.prospecto.usuario_asignado = this.usuario;
        this.cargar = true
        return this.$http.post("cambiar.prospecto.updateprospectovendedora", this.prospecto).then((response) => {
          this.dialogUsuario = false;
          this.cargar = false
          this.prospecto = null;
          this.initialize();
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      verContactos( value ){

        console.log( value )
        this.tablaContactos = value
        this.dialogMensajes     = true


      },

      verInscritos( value ){

        this.tablaAlumnos   = value
        this.dialogAlumnos  = true

      },

      previewLink( item ){
        window.open(item.ReferralSourceUrl, '_blank')

      },

      verEnWEB( item ){

      },

      evento() {

        console.log( this.getdatosUsuarioERPERP )
  this.$http.get(`evento-por-usuario?id=${this.getdatosUsuarioERPERP.id_usuario}`)
    .then(response => {

      //console.log( response.data[0] )
      if (response.data[0].confirmacion === null) {


        if( [1, 4].includes( +response.data[0].estado) ) this.ciudad = 'mty'
        if( response.data[0].id_plantel === 13 ) this.ciudad = 'mty'
        if( [ 2 ].includes( +response.data[0].estado ) ) this.ciudad = 'cdmx'

        //console.log('Mostrar invitacion en base a ciudad de usuario');
        //console.log(this.ciudad);

        this.$swal({
          title: '¡Tienes una invitación!',
          text: '¿Deseas confirmar tu asistencia al evento?',
          imageUrl: this.ciudad === 'mty' ? invitacionMty : invitacionCDMX, // tu invitación digital
          imageWidth: 300,
          imageHeight: 400,
          imageAlt: 'Invitación Digital',
          showCancelButton: true,
          confirmButtonText: 'Sí',
          cancelButtonText: 'No',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.guardarRespuesta(1);
          } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            this.guardarRespuesta(0);
          }
        });
      }
    })
    .catch(error => {
      this.validarError(error);
    });
},

guardarRespuesta(confirmacion) {


  this.$http.post('evento-confirmacion', {
    confirmacion,
    idusuario: this.getdatosUsuarioERPERP.id_usuario,
    idevento: this.ciudad === 'mty' ? 1 : 2
  })
  .then(() => {
    this.$swal({
      icon: 'success',
      title: 'Respuesta guardada',
      text: confirmacion ? 'Has confirmado tu asistencia.' : 'Has rechazado el evento.',
      confirmButtonText: 'Aceptar'
    });
  })
  .catch(error => {
    this.$swal({
      icon: 'error',
      title: 'Error',
      text: error,
      confirmButtonText: 'Aceptar'
    });
  });
}


    },
  };
</script>
